interface CalendarSlotProps {
  date: string;
  time: string;
  isSelected: boolean;
  onClick: () => void;
}

export default function CalendarSlot({
  date,
  time,
  isSelected,
  onClick,
}: CalendarSlotProps) {
  return (
    <button
      onClick={onClick}
      className={`w-full p-4 rounded-lg border-2 transition-all duration-300 ${
        isSelected
          ? 'border-accent bg-accent/5 shadow-md'
          : 'border-border hover:border-accent/50 hover:shadow-sm'
      }`}
    >
      <div className="text-sm font-medium text-foreground mb-1">{date}</div>
      <div className="text-lg font-heading font-semibold text-accent">{time}</div>
    </button>
  );
}